module.exports = __webpack_public_path__ + "7aff82c18772cf20db9842363fcf69e4.png";